export const documentationLinks = {
    base: "https://digitalgizmo.atlassian.net/wiki/x/CgFcbg"
};
